/** Restores the report's saved section choices when the report options menu is switched on. */
import { useEffect } from 'react';
import { usePdfReportSections } from '@/features/client-onboarding';
import { useFeatureFlags } from '@client/contexts/FeatureFlagsContext';

export function useReportSectionOptions() {
  const { flags } = useFeatureFlags();
  const { hydrate } = usePdfReportSections();
  const isEnabled = flags.onboardingPdfReportOptions === true;

  useEffect(() => {
    if (isEnabled) hydrate();
  }, [hydrate, isEnabled]);
}
